<ng-container [ngSwitch]="mode">

    <mat-form-field class="control-field" appearance="outline" *ngSwitchCase="'text'">
        <input #textInput fxFlex matInput type="search" [value]="text" [disabled]="disabled"
            (input)="onTextChange(textInput.value)">
        <span matSuffix class="filter-mode-toggle" [class.disabled]="disabled"
            [matTooltip]="'column-filter.mode-text' | translate"
            (click)="toggleMode($event)">
            <mat-icon>search</mat-icon>
        </span>
    </mat-form-field>

    <mat-form-field class="control-field" appearance="outline" *ngSwitchDefault>
        <!-- disableRipple: efekt fali na pozycji listy filtra nic nie wnosi, a mierzalnie kosztuje -
             ok. 20% czasu budowy listy (MatRipple to osobna dyrektywa przy każdej pozycji). -->
        <mat-select multiple disableRipple disableOptionCentering panelClass="filter-value-panel" #valueSelect="matSelect"
            [value]="selectionValue" [disabled]="disabled"
            (mousedown)="ensureOptionsLoaded()" (focus)="ensureOptionsLoaded()"
            (selectionChange)="onSelectionChange($event.value)"
            (openedChange)="onOpenedChange($event)">

            <!-- Zawartość zwiniętego pola musi zostać zwykłym tekstem w linii (bez własnego
                 kontenera blokowego) - mat-select wycina ją wielokropkiem przez komórkę
                 .mat-select-value, a ta radzi sobie tylko z zawartością liniową. -->
            <mat-select-trigger><ng-container
                    *ngFor="let option of selectedLabels; let last = last"><span
                    class="selected-option-html" *ngIf="option.isHtml; else labelText"
                    [innerHtml]="option.value"></span><ng-template
                    #labelText>{{ option.value | translate }}</ng-template><ng-container
                    *ngIf="!last">, </ng-container></ng-container></mat-select-trigger>

            <!-- PPM w panelu ma nie robić nic (czyszczenie filtra zostaje na komórce nagłówka) -
                 samo zdjęcie menu przeglądarki, żeby nie przykrywało rozwiniętej listy. -->
            <div #panelContent class="filter-value-panel-content" (scroll)="onPanelScroll($event)"
                 (contextmenu)="$event.preventDefault()">
                <div class="filter-option-tools" (click)="$event.stopPropagation()">
                    <div class="filter-option-search" *ngIf="showSearch">
                        <i class="pi pi-search"></i>
                        <input #searchInput type="text" [placeholder]="'column-filter.search' | translate"
                            [ngModel]="search" (ngModelChange)="onSearchChange($event)"
                            (contextmenu)="onSearchContextMenu($event)"
                            (keydown)="onSearchKeydown($event)">
                        <i class="pi pi-times cursor-pointer" *ngIf="search" (click)="onSearchChange('')"></i>
                    </div>
                    <div class="filter-option-actions">
                        <mat-checkbox color="primary" disableRipple
                            (keydown.space)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
                            [checked]="allMatchingSelected"
                            [indeterminate]="someMatchingSelected && !allMatchingSelected"
                            (change)="toggleAllMatching()">
                            {{ (search ? 'column-filter.select-all-matching' : 'column-filter.select-all') | translate }}
                        </mat-checkbox>
                        <!-- Licznik jest zarazem przełącznikiem: zawęża listę do zaznaczonych,
                             żeby dało się je przejrzeć bez szukania po całości. -->
                        <span class="filter-option-count" [class.active]="showSelectedOnly"
                            [matTooltip]="(showSelectedOnly ? 'column-filter.show-all' : 'column-filter.show-selected-only') | translate"
                            (click)="toggleShowSelectedOnly()">{{ selectedCount }}/{{ totalCount }}</span>
                    </div>
                </div>

                <!-- Numer pozycji wchodzi atrybutem, bo treść mat-option projektuje się dopiero za
                     checkboxem, a liczba ma być przed nim - rysuje ją pseudoelement (patrz styl). -->
                <mat-option *ngFor="let option of renderedOptions; let i = index" [attr.data-index]="i + 1"
                    [value]="option.key" [disabled]="option.disabled">
                    <span *ngIf="option.isHtml; else showTextOption" [innerHtml]="option.value"></span>
                    <ng-template #showTextOption>{{ option.value | translate }}</ng-template>
                </mat-option>

                <!-- mat-select odmawia otwarcia panelu, gdy nie ma ani jednej opcji (_canOpen), a
                     lista z danych liczy się dopiero przy otwarciu - ta pozycja zastępcza przerywa
                     to błędne koło i przy okazji jest komunikatem "brak wartości". -->
                <mat-option *ngIf="!renderedOptions.length" class="filter-value-empty-option" [disabled]="true">
                    {{ 'column-filter.no-values' | translate }}
                </mat-option>

                <div class="filter-value-panel-note" *ngIf="hiddenCount > 0">
                    {{ 'column-filter.more-values' | translate : { shown: visibleMatchingCount, total: matchingCount } }}
                </div>
            </div>
        </mat-select>

        <!-- Licznik musi wisieć poza mat-selectem: własny trigger renderuje się tylko wtedy, gdy
             model zaznaczenia nie jest pusty, a ten zna jedynie wyrenderowane opcje - dla listy
             budowanej z danych (jeszcze nie policzonej) pole byłoby przez to zupełnie puste. -->
        <!-- Sama liczba, bez mianownika - w wąskiej kolumnie każdy znak to znak mniej dla
             wypisanych wartości; ile jest do wyboru, mówi podpowiedź. Kolor niesie stan: wyszarzony
             to "wszystko" (kolumna nie filtruje), akcent to wybór, czerwony to "nic".
             Bez *ngIf: element z matSuffix jest projektowany do slotu sufiksu przez
             @ContentChildren mat-form-fielda i dołożona strukturalna dyrektywa gubi projekcję -
             ukrywamy więc stylem. -->
        <span matSuffix class="selected-count"
            [class.selected-count-hidden]="!showCount"
            [class.all-selected]="allSelected"
            [class.nothing-selected]="!allSelected && !values.length"
            [matTooltip]="countTooltip | translate : { count: selectedCount, total: totalCount }">
            {{ selectedCount }}
        </span>

        <span matSuffix class="filter-mode-toggle" [class.disabled]="disabled" *ngIf="allowText"
            [matTooltip]="'column-filter.mode-list' | translate"
            (click)="toggleMode($event)">
            <mat-icon>manage_search</mat-icon>
        </span>
    </mat-form-field>

</ng-container>
